import TabType7 from "./tabType7";

export default TabType7;
